import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {

  1: {
    // Exercise num
    unit: 'Unit 4',
    id: 'WB4-V2-U4-P33-E1',
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page33/E1/Key/answerKey.png",
    inputSize: 450,
    checkUppercase: true,
    // titleImage: "img/FriendsPlus/Page45/E1/title.jpg",
    titleQuestion: [{ color: '#3F3478', num: '1', title: "Write the sentence with capilta letters." }],
    questionImage: [],
    questions: [
      {
        title: `
          <div >
              <div><b>1 </b> we have music on tuesday.<u style='color: gray;'><i> We have music on Tuesday.</i></u></div>
              <div><b>2</b> what do we have on thursday? # </div>
              <div><b>3</b> do we have math on monday? #</div>
              <div><b>4</b> we don't have school on saturday #</div>
              <div><b>5</b> what do we have on wednesday? #</div>
              <div><b>6</b> we have art on wednesday. #</div>
          </div>
        `,
        answer: [
          "What do we have on Thursday?",
          "Do we have math on Monday?",
          "We don't have school on Saturday.",
          "What have got on Wednesday?",
          "We have art on Wednesday.",
        ],
      },
    ],
  },
  2: { // Exercise num
    unit: 'Unit 4',
    id: 'WB4-V2-U4-P33-E2',
    audio: '',
    video: '',
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page33/E2/1.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page33/E2/2.jpg' },
      ],
    ]
  },
  3: { // Exercise num
    unit: 'Unit 4',
    id: 'WB1-U4-P33-E1',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    exerciseKey: 'img/FriendsPlus/Page33/E3/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page33/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page33/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page33/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page33/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page33/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page33/E3/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page33/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/14.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/15.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page33/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/17.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/18.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page33/E3/19.jpg' },
        { url: 'img/FriendsPlus/Page33/E3/20.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page33/E3/21.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page33/E3/22.jpg' },
      ],

    ]
  },

}

export default json;